module.exports = __webpack_public_path__ + "static/media/ic_unlink_url.af2f4bee.svg";